<template>
    <StepDescription
        v-if="currentStep === steps.VEHICLE_CATEGORY"
        :stepDescription="'Selecione a categoria de veículos que você utiliza para fazer entregas'"
    />
    <StepDescription
         v-if="currentStep != steps.VEHICLE_CATEGORY"
        :stepDescription="'Selecione o veículo que você utiliza para fazer as entregas'"
    />
    <CardTypeVehicle
    v-if="currentStep === steps.VEHICLE_CATEGORY"
        v-for="(category, i) in categories" :key="i"
        :typeVehicle="categories[i]"
        :typeVehicleDescription="descriptionsCategories[i]"
        @click.native="selectCategoryVehicle(categories[i])"
    />
    <CardTypeVehicle
    v-if="currentStep === steps.LEVE_VEHICLE"
        v-for="(category, i) in vehicleLeveTitle" :key="i"
        :typeVehicle="vehicleLeveTitle[i]"
        :typeVehicleDescription="vehicleLeveDescription[i]"
        :visibleIcon="true"
        :srcIconVehicle="vehicleLeveIcon[i]"
        :visibleIconNextStep="false"
        @click.native="selectVehicle(formattedLeveTitle[i])"
        :isSelected="formattedLeveTitle[i] === nameVehicleSelected"
    />
    <CardTypeVehicle
    v-if="currentStep === steps.VUCS_VEHICLE"
        v-for="(category, i) in vehicleVucsTitle" :key="i"
        :typeVehicle="vehicleVucsTitle[i]"
        :typeVehicleDescription="vehicleVucsDescription[i]"
        :visibleIcon="true"
        :srcIconVehicle="vehicleVucsIcon[0]"
        :visibleIconNextStep="false"
        @click.native="selectVehicle(formattedVucsTitle[i])"
        :isSelected="formattedVucsTitle[i] === nameVehicleSelected"

    />
    <CardTypeVehicle
    v-if="currentStep === steps.PESADO_VEHICLE"
        v-for="(category, i) in vehiclePesadoTitle" :key="i"
        :typeVehicle="vehiclePesadoTitle[i]"
        :typeVehicleDescription="vehiclePesadoDescription[i]"
        :visibleIcon="true"
        :srcIconVehicle="vehiclePesadoIcon[0]"
        :visibleIconNextStep="false"
        @click.native="selectVehicle(formattedPesadoTitle[i])"
        :isSelected="formattedPesadoTitle[i] === nameVehicleSelected"
    />
    <FooterButton v-if="currentStep === steps.VEHICLE_CATEGORY" :isDisabled="true"/>
    <FooterButton v-if="currentStep != steps.VEHICLE_CATEGORY" :confirmData="confirmData" :is-disabled="disableSubmit"/>
</template>
<script>
    import CardTypeVehicle from '../../components/CardTypeVehicle.vue';
    import FooterButton from '../../components/FooterButton.vue';
    import StepDescription from '../../components/StepDescription.vue';
    import { ref } from 'vue';
    import { useStore } from '../../../stores/cadastro.js';
    import { useRouter } from 'vue-router';
    import axios from 'axios';

    import TwoWheeler from '../../../../public/images/two_wheeler.svg';
    import DirectionsCar from '../../../../public/images/directions_car.svg';
    import AirportShuttle from '../../../../public/images/airport_shuttle.svg';
    import LocalShipping from '../../../../public/images/local_shipping.svg';
    import Swal from 'sweetalert2';


    export default {
        components: {
            CardTypeVehicle,
            FooterButton,
            StepDescription
        },
        data(){
            return{
                categories: ['Veículos leves', 'VUCs', 'Veículos pesados'],
                descriptionsCategories: ['Capacidade de até 1000kg. Exemplos: motos, veículos de passeio, utilitários pequenos e vans.', 'Vucs com capacidade de até 2500kg', 'Capacidade de até 27000kg. Exemplos: Tocos, trucks, bi-trucks e carretas.'],

                vehicleLeveTitle: ['Moto', 'Veículos de passeio', 'Utilitário pequeno', 'Van'],
                formattedLeveTitle: ['MOTO', 'PASSEIO', 'FIORINO', 'VAN'],
                vehicleLeveDescription: ['Capacidade de até 20kg. Exemplos: motocicletas CG125 e similares com baú', 'Capacidade de até 200kg. Exemplos: Sedan, Hatch e similares.', 'Capacidade de até 500kg. Exemplos: Fiorino, Kangoo e similares.', 'Capacidade de até 1000kg. Exemplos: Ducato, Kombi e similares.' ],
                vehicleLeveIcon: [TwoWheeler, DirectionsCar, AirportShuttle, AirportShuttle],

                vehicleVucsTitle: ['VUC pequeno', 'VUC médio', 'VUC grande'],
                formattedVucsTitle: ['HR', 'IVECO', '3/4'],
                vehicleVucsDescription: ['Capacidade de até 1500kg. Exemplos: HR, Kia Bongo e similares.', 'Capacidade de até 2500kg. Exemplos: Iveco e similares.', 'Capacidade de até 2500kg. Exemplos: Iveco e similares.'],
                vehicleVucsIcon: [LocalShipping],

                vehiclePesadoTitle: ['Toco', 'Truck', 'Bi-truck', 'Carreta'],
                formattedPesadoTitle: ['TOCO', 'TRUCK', 'BITRUCK', 'CARRETA'],
                vehiclePesadoDescription: ['Capacidade de até 6000kg.', 'Capacidade de até 15000kg.', 'Capacidade de até 20000kg.', 'Capacidade de até 27000kg.'],
                vehiclePesadoIcon: [LocalShipping],
                disableSubmit: false,
            }
        },
        setup() {
            const router = useRouter();
            const store = useStore();
            const currentStep = ref(1);
            const disableSubmit = ref(false);
            const steps = {
                VEHICLE_CATEGORY: 1,
                LEVE_VEHICLE: 2,
                VUCS_VEHICLE: 3,
                PESADO_VEHICLE: 4
            }

            function confirmCurrentStep(){
                if(currentStep.value <= Object.keys(steps).length){
                    currentStep.value++
                }
            }

            function selectCategoryVehicle(categories) {
                if(categories === 'Veículos leves'){
                    currentStep.value = steps.LEVE_VEHICLE
                }else if(categories === 'VUCs') {
                    currentStep.value = steps.VUCS_VEHICLE
                }else if (categories === 'Veículos pesados') {
                    currentStep.value = steps.PESADO_VEHICLE
                }
            }

            let nameVehicleSelected = ref(null);
            function selectVehicle(vehicleTitle){
                nameVehicleSelected.value = vehicleTitle
            }

            const confirmData = async () => {
                if(nameVehicleSelected.value == null) {
                    Swal.fire({
                        title: 'Ops...',
                        text: 'Escolha um veículo para continuarmos com o seu cadastro.',
                        icon: 'warning',
                        confirmButtonText: 'Ok'
                    });
                    return;
                }

                let canResubmit = true;

                await store.updatePreRegistrationData({ vehicle_type: nameVehicleSelected.value });
                const data = store.getRegistrationData;
                data.registration_steps = {completed: false, bank_data: false, personal_data: false, vehicle_data: false, documents: false};
                disableSubmit.value = true;
                try {
                    const response = await axios.post('/cadastro-motorista/novo', {
                        data: data
                    });
                    if (response.data && response.data.id) {
                        canResubmit = false;
                        store.setDriverId(response.data.id);
                    }
                    Swal.fire({
                        title: 'Cadastro realizado com sucesso!',
                        text: 'Seu pré cadastro foi feito, por favor informe o restante dos dados nos passos seguintes.',
                        icon: 'success',
                        allowOutsideClick: false,
                        timer: 10000,
                        timerProgressBar: true,
                        showConfirmButton: true,
                        confirmButtonText: 'Ok'
                    }).then(() => {
                        if (response.status == 201) {
                            router.push({ name: 'StatusRegistration' });
                        }
                    });
                } catch (error) {
                    if (error.response && error.response.status === 409) {
                      router.push({ name: 'WarningScreen' });
                    } else if (error.response && error.response.status === 422) {
                      const htmlItems = Object.entries(error.response.data.reasons).map(
                          ([key, value]) => `<li><strong>${key}:</strong> ${value}</li>`
                        )
                      const html = `<p>Verifique os seguintes erros:</p><ul>${htmlItems.join('')}</ul>`;

                      Swal.fire({
                        icon: 'warning',
                        title: 'Dados inválidos',
                        html,
                      });
                    } else {
                        console.error('Erro inesperado:', error);
                        Swal.fire({
                            title: 'Ops...',
                            text: 'Erro inesperado, por favor tente novamente mais tarde.',
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        });
                    }
                } finally {
                    disableSubmit.value = canResubmit;
                }
            };
            return {
                confirmCurrentStep,
                selectCategoryVehicle,
                selectVehicle,
                confirmData,
                steps,
                currentStep,
                nameVehicleSelected,
                disableSubmit,
            };
        },
    }
</script>
